// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import generateSearchQuery from '../../helpers/generateSearchQuery'

const { axiosIns } = useJwt
export default {
  getBlackListAction: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/TransactionMonitoring/v1/SearchBlacklist',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createBlackListAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/TransactionMonitoring/v1/AddToBlacklist', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  removeBlackListItemAction: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.delete('/accounting/api/TransactionMonitoring/v1/RemoveBlacklist', { data: { id } })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getWhiteListAction: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/TransactionMonitoring/v1/SearchWhitelist',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createWhiteListAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/TransactionMonitoring/v1/AddToWhitelist', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  removeWhiteListItemAction: async (context, { id, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.delete('/accounting/api/TransactionMonitoring/v1/RemoveWhitelist', { data: { id } })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTransactionRule: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/accounting/api/TransactionMonitoring/v1/SearchTransactionRule',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateTransactionStatus: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Active' ? 'Activate' : 'Deactivate'
      const response = await axiosIns.put(`/accounting/api/TransactionMonitoring/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTransactionRules: async (context, { permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        '/accounting/api/TransactionMonitoring/v1/GetRules',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createTransactionRuleAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/accounting/api/TransactionMonitoring/v1/AddTransactionRule', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateTransactionRuleAction: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.put(
        '/accounting/api/TransactionMonitoring/v1/UpdateTransactionRule',
        formData,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  updateOpenCloseStatusAction: async (context, { statusValues, actionType, permission }) => {
    try {
      useJwt.setPermission(permission)
      const route = actionType === 'Open' ? 'OpenCase' : 'CloseCase'
      const response = await axiosIns.put(`/accounting/api/TransactionMonitoring/v1/${route}`, statusValues)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSanctionScreening: async (context, {
    search, page, limit = 10, permission,
  }) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/kyc/api/Kyc/v1/SearchBlacklist',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  createSanctionScreening: async (context, { formData, permission }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post('/kyc/api/Kyc/v1/AddBlacklist', formData)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
